import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Tooltip, Input, notification, Row } from "antd";
import SpeechAudio from "../../pages/LineDashboardMQ/SpeechAudio";
import LinePopup from "../../pages/LineDashboardMQ/LinePopup";
import ZenFormInput from "../../pages/InputCreater/ZenFormInput";

function Scanter({ disableScanter, id = "scanter-barcode", onBlur = () => { }, onFocus = () => { }, onFinish, form, label, type, disabled, confirmationPopUp, setSelectedButton, button, openPopupModal, postSubmitAction }) {
    const [barCodeForm] = Form.useForm();
    const [popupEnabled, setPopupEnabled] = useState(false);
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
    const LocalDict = [];
    const [buttonAttr, setButtonAttr] = useState({
        className: 'scan-btn',
        text: 'Click To Scan'
    });
    const [cursorOnBtn, setCursonOnBtn] = useState(false);

    const [buttonData, setButtonData] = useState({
        label,
        css: {
            display: "flex",
            justifyContent: "center",
            marginBottom: 0,
            textAlign: "center",
        }
    });
    const [tooltip, setTooltip] = useState({
        visible: false,
        message: ''
    });


    useEffect(() => {
        document.getElementById(id).focus();
        let focusInterval = setInterval(() => {
            let element = document.activeElement;
            if (element.tagName.toLowerCase() !== 'input') {
                document.getElementById(id).focus();
                setButtonAttr({ ...buttonAttr, className: 'btn-scanned', text: 'Scan Part' });
            }
        }, 2000);
        if (disableScanter || popupEnabled) {
            clearInterval(focusInterval);
            document.getElementById(id).blur();
            setButtonAttr({ ...buttonAttr, className: 'scan-btn', text: 'Click To Scan' });
        }
        return () => {
            clearInterval(focusInterval);
        }
    }, [disableScanter, popupEnabled]);

    const onOk = (barCode) => {
        // barCodeForm.resetFields();
        if (button?.buttonProp.submitFormData) {
            if (onFinish) {
                return onFinish({ button, barCode });
            }
        };
        if (button?.buttonProp.postSubmitAction) {
            return postSubmitAction({ button, barCode });
        }
    }

    const onSave = (values) => {
        let { barCode } = values;
        if (setSelectedButton) {
            setSelectedButton(button);
        };
        if (confirmationPopUp) {
            Modal.confirm({
                title: confirmationPopUp["text"],
                okText: confirmationPopUp["okButtonLabel"],
                cancelText: confirmationPopUp["cancelButtonLabel"],
                cancelButtonProps: { ghost: true },
                okButtonProps: { ghost: true, danger: true },
                onOk: () => onOk(barCode)
            });
        } else {
            // barCodeForm.resetFields();
            if (button?.buttonProp?.submitFormData) {
                return onFinish({ button, barCode, values });
            };
            if (button?.buttonProp?.popUpModal) {
                return openPopupModal(button);
            };
            if (button?.buttonProp?.postSubmitAction) {
                return postSubmitAction({ button, barCode, values })
            }
        }
    }

    const onSaveHandler = (values) => {
        let { barCode } = values;
        barCodeForm.resetFields(['barCode']);
        document.getElementById(id).focus();
        if (button?.buttonProp?.validateFields) {
            barCodeForm
                .validateFields()
                .then(() => {
                    let validBarCodes = button?.validateFieldsProp?.validList;
                    let barCodeLength = button?.validateFieldsProp?.lengthOfString;
                    let barCodePrefix = button?.validateFieldsProp?.prefix;
                    if (barCodeLength.enable) {
                        if (!barCodeLength?.criteria?.includes(barCode.length)) {
                            return notification.error({ message: barCodeLength.msg + `: ${barCode}` });
                        }
                    };
                    if (barCodePrefix.enable) {
                        let prefixMatch = false;
                        barCodePrefix.criteria.forEach(x => {
                            if (barCode.startsWith(x)) {
                                prefixMatch = true;
                            }
                        });
                        if (!prefixMatch) {
                            return notification.error({ message: barCodePrefix.msg + `: ${barCode}` });
                        };
                    };
                    if (validBarCodes.enable) {
                        if (!validBarCodes?.criteria?.includes(barCode)) {
                            return notification.error({ message: validBarCodes.msg + `: ${barCode}` });
                        };
                    }
                    // barCodeForm.resetFields();
                    onSave(values);
                })
                .catch((errors) => {
                    // let inputFieldName = "ReportForm_" + errors.errorFields[0].name.join("_");
                    // document.getElementById(inputFieldName).focus();
                    // return;
                    // Errors in the fields
                });
        } else {
            // barCodeForm.resetFields();
            onSave(values);
        }
    };


    const queryElements = (controls) => {
        return (
            <Row justify={"space-between"} style={{ alignItems: 'center' }}>
                {
                    controls.map((data, index) => {
                        if (dtArray.includes(data["typ"])) {

                            LocalDict[data["din"]] = data["format"]
                                ? data["format"]
                                : "YYYY-MM-DD hh:mm:ss";
                            LocalDict["din_from"] = data["din_from"];
                            LocalDict["din_to"] = data["din_to"];
                        }

                        if (data.visible) {
                            return (
                                <React.Fragment key={index}>
                                    <ZenFormInput
                                        //    urlData={{ ...urlData }}
                                        childType={data.childType}
                                        pageType={"zenForm"}
                                        header={data.header}
                                        footer={data.footer}
                                        labelColSpan={data["labelColSpan"]}
                                        style={data['style']}
                                        height={data['height']}
                                        layoutPosition="space-between"
                                        form={barCodeForm}
                                        LocalDict={LocalDict}
                                        rows={data.rows}
                                        colSpan={data.colSize || 12}
                                        name={data["din"]}
                                        label={data["label"]}
                                        defaultValue={data["default"]}
                                        typ={data["typ"]}
                                        disabled={data["readOnly"]}
                                        source={data["source"]}
                                        sourceParams={data["sourceParams"]}
                                        auxParams={data["auxParams"]}
                                        format={data["format"]}
                                        errorMessage={data["errorMessage"]}
                                        placeHolder={data["placeHolder"]}
                                        required={data["required"]}
                                        options={data["data"]}
                                        from={data["din_from"]}
                                        to={data["din_to"]}
                                        url={data["url"]}
                                        includeAll={data["includeAll"]}
                                        pname={data["p_din"]}
                                        defaultFrom={data["defaultFrom"]}
                                        defaultTo={data["defaultTo"]}
                                        multiSelect={data["multiSelect"]}
                                        searchable={data["isSearchable"]}
                                        data={data}
                                        //   extraData={extraData}
                                        children={data['children']}
                                    />
                                </React.Fragment>
                            );
                        }
                    })}
            </Row>)
    }

    const _onBlur = () => {
        if (!cursorOnBtn) {
            setButtonAttr({ ...buttonAttr, className: 'scan-btn', text: 'Click To Scan' });
            onBlur();
            // setScanResult(null);
        };
    }

    const scanButton = () => {
        document.getElementById(id).focus();
        setButtonAttr({ ...buttonAttr, className: 'btn-scanned', text: 'Scan Part' });
        onFocus();
    };

    const isFocused = () => {
        const input = document.getElementById(id);
        if (document.activeElement === input) {
            return true;
        }
        return false;
    }

    return (
        <div className="AuditSection CreateAudit">
            {
                button?.buttonProp?.showScanBtn ?
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
                        <div
                            onMouseOver={
                                () => setCursonOnBtn(true)
                            }
                            onMouseOut={
                                () => setCursonOnBtn(false)
                            }
                            onClick={scanButton}
                            className={`linedashboard-scan-btn ${buttonAttr.className}`}>
                            {buttonAttr.text}
                        </div>
                    </div> : null
            }

            <div className="phantom-form ThemeForm">
                <Form
                    onFinishFailed={() => barCodeForm.resetFields(['barCode'])}
                    size="large"
                    className={!button?.buttonProp?.visible ? "scanter-form-hidden" : ""}
                    form={barCodeForm}
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    onFinish={onSaveHandler}
                    autoComplete="off"
                >
                    {
                        button?.buttonProp?.modalElements ? (
                            <>
                                {queryElements(button?.modalElements)}
                            </>
                        ) : <></>
                    }
                    <Form.Item
                        label="Barcode"
                        name="barCode"
                    >
                        <Input
                            disabled={disabled}
                            className={isFocused() ? "scanter-input focused" : "scanter-input unfocused"}
                            placeholder={isFocused() ? "Enter BarCode" : "Click To Scan"}
                            onBlur={_onBlur}
                            onFocus={scanButton}
                            id={id}
                        />
                    </Form.Item>
                    <Button style={{ display: 'none' }} htmlType="submit">Submit</Button>
                </Form>
            </div>
            {
                button?.buttonProp?.tts ?
                    <SpeechAudio auxFunctions={button?.ttsProp} selectedLid={""} /> : <></>
            }
            {
                button?.buttonProp?.popUpMsg ?
                    <LinePopup setPopupEnabled={setPopupEnabled} auxFunctions={button?.popUpMsgProp} selectedLid={""} refreshLineDashboard={() => { }} /> : <></>
            }
        </div >

    );
}

export default Scanter;